import { useCallback } from 'react';

import { OnboardingFeatureKey } from '@gokrew/models/company';
import { useAuth } from '@/context/AuthContext';

/**
 * Whether a module is switched on for this company, as set in Organisation.
 *
 * Defaults to on while the flags are still loading. Flashing whole blocks out
 * and back in on every page load reads as a glitch, whereas a module that is
 * genuinely off simply disappears a moment later.
 */
export function useModuleEnabled() {
  const { featureFlags } = useAuth();

  return useCallback(
    (key: OnboardingFeatureKey) => featureFlags?.[key] ?? true,
    [featureFlags]
  );
}
